module.exports = __webpack_public_path__ + "img/dcu30.cf64d669.png";